export const SvgArrowMore = () => (
  <svg width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.67016 8L13 4.67016L9.67016 1.34032" stroke="#2D5381" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M12.6545 4.67004L1.00009 4.67004" stroke="#2D5381" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);